import { Injectable } from '@angular/core';
import {
  Auth,
  createUserWithEmailAndPassword,
  getAuth,
  signInWithEmailAndPassword,
} from '@angular/fire/auth';
import {
  collection,
  doc,
  DocumentData,
  Firestore,
  getDoc,
  getDocs,
  query,
  setDoc,
  where,
} from '@angular/fire/firestore';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { User } from '../../models/user';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private auth: Auth,
    private router: Router,
    private firestore: Firestore
  ) {
    this.auth = getAuth();
  }

  login(email: string, password: string) {
    return signInWithEmailAndPassword(this.auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        localStorage.setItem('id', JSON.stringify(user.uid));
        return user;
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        return null;
      });
  }

  register(email: string, password: string) {
    return createUserWithEmailAndPassword(this.auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        localStorage.setItem('id', JSON.stringify(user.uid));
        return user;
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        return null;
      });
  }

  createUser(user: User): Promise<Boolean> {
    return new Promise(async (resolve, reject) => {
      if (user.id) {
        await setDoc(doc(this.firestore, 'users', user.id), user);
        resolve(true);
      } else {
        reject(false);
      }
    });
  }

  getUserById(id: string): Promise<DocumentData | null>{
    return new Promise(async (resolve, reject) => {
      const docRef = doc(this.firestore, 'users', id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        resolve(docSnap.data());
      } else {
        reject(null);
      }
    });
  }

  isLoggedIn(): Observable<boolean> {
    return new Observable((observer) => {
      this.auth.onAuthStateChanged((user) => {
        if (user) {
          observer.next(true);
        } else {
          observer.next(false);
        }
      });
    });
  }

  logout() {
    this.auth.signOut().then(() => {
      localStorage.clear();
      this.router.navigate(['/login']);
    });
  }

  getUserToken() {
    return getAuth().currentUser?.getIdToken();
  }

  getUserInfo() {
    return getAuth().currentUser;
  }
}
